var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-group",class:{ m_line_group: _vm.isMobile, small_line_group: _vm.size === 'small' }},[_c('div',{staticClass:"line1"}),_c('div',{staticClass:"line2"})])}
var staticRenderFns = []

export { render, staticRenderFns }